var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallListen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "white",
    stroke: "#F8153B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2532_1705",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2532_1705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 27.333V25.9997H24.6667V25.333H22V19.9997H24.6667V19.333C24.6667 18.0441 24.2111 16.9441 23.3 16.033C22.3889 15.1219 21.2889 14.6663 20 14.6663C18.7111 14.6663 17.6111 15.1219 16.7 16.033C15.7889 16.9441 15.3333 18.0441 15.3333 19.333V19.9997H18V25.333H15.3333C14.9667 25.333 14.6528 25.2025 14.3917 24.9413C14.1306 24.6802 14 24.3663 14 23.9997V19.333C14 18.5108 14.1583 17.7358 14.475 17.008C14.7917 16.2802 15.2222 15.6441 15.7667 15.0997C16.3111 14.5552 16.9472 14.1247 17.675 13.808C18.4028 13.4913 19.1778 13.333 20 13.333C20.8222 13.333 21.5972 13.4913 22.325 13.808C23.0528 14.1247 23.6889 14.5552 24.2333 15.0997C24.7778 15.6441 25.2083 16.2802 25.525 17.008C25.8417 17.7358 26 18.5108 26 19.333V25.9997C26 26.3663 25.8694 26.6802 25.6083 26.9413C25.3472 27.2025 25.0333 27.333 24.6667 27.333H20Z",
    fill: "#F8153B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallListen);
export default __webpack_public_path__ + "static/media/callListen.f918c31656a27d8a9ebccf0ca4be3487.svg";
export { ForwardRef as ReactComponent };